import Dashboard from "../Layout/Dashboard";
import ExcelMedicalCasesUploader from "./CreateMasiveCase";

function CaseMasive() {
  return (
    <Dashboard
      headerTitle="Carga masiva de casos"
      panelClassName="w-12 md:w-9 lg:w-12"
    >
      { <ExcelMedicalCasesUploader /> }
    </Dashboard>
  );
}

export default CaseMasive;
